import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import type { CustomerLoyaltyProgram } from "../components/data/types"
import { request } from "../utils/http"

export type GetCustomerServerResponse = {
    content: CustomerResponseItem[]
    total_count: number
    page_size: number
}

export type CustomerResponseItem = {
    id: string
    is_company: boolean
    company_name?: Maybe<string>
    position?: string
    date_of_birth: string
    deleted: boolean
    email_address?: string
    first_name?: string
    gender?: string
    origin_terminal_id: string
    origin_timestamp: string
    origin_user_account_id: string
    origin_user_name?: string
    payment_card_ids: string[]
    phone_number?: string
    surname?: string
    tags: any[]
    title?: string
    version: number
    customer_loyalty_programs: CustomerLoyaltyProgram[]
    addresses: CustomerAddressResponseItem[]
    notes: CustomerNoteResponseItem[]
}

export type CustomerAddressResponseItem = {
    id: string
    city: Maybe<string>
    customer_id: string
    line1: Maybe<string>
    line2: Maybe<string>
    state: Maybe<string>
    type: Maybe<string>
    version: number
    zip: string
}

export type CustomerNoteResponseItem = {
    customer_id: string
    deleted: boolean
    id: string
    note?: string
    origin_terminal_id: string
    origin_timestamp: string
    origin_user_account_id: string
    origin_user_name?: string
    version: number
}

export const getCustomerDetailApi = (
    headers: Record<string, any>,
    id: string
): Rx.Observable<GetCustomerServerResponse> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: `/data/customer?filter=id.in(${id})`,
            headers: headers,
        })
    ).pipe(retry(3))
